import { inject, Injectable } from '@angular/core';
import { AlertDialogService } from '../alert-dialog/alert-dialog.service';
import { AlertDialogOptions } from '../../models/alert-dialog-options.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoggerService } from '../logger.service';

@Injectable({
  providedIn: 'root',
})
export class ExceptionHandlingService {
  private readonly alertDialogService = inject(AlertDialogService);
  private readonly router = inject(Router);

  public handleExceptionWithAlert(exceptionName: string, exception: any, alertDialogOptions?: AlertDialogOptions) {
    // Log exception
    LoggerService.ERROR(this, exceptionName, exception);
    // Define default strings if no options are given
    if (!alertDialogOptions) {
      alertDialogOptions = {
        title: 'FEHLER_ALLGEMEIN',
        message: '',
        feedbackState: 'error',
      };
      // Add helpful error message from API if present
      try {
        exception.error = JSON.parse(exception.error);
      } catch (probablyNotJson) {
        // Nothing to do here.
      }
      if (exception.error && exception.error.message) {
        if (Array.isArray(exception.error.message)) {
          alertDialogOptions.message = exception.error.message.join(', ');
        } else {
          alertDialogOptions.message = exception.error.message;
        }
      }
      // Add URL
      if (exception.url) {
        let url = exception.url;
        try {
          url = URL.parse(exception.url)?.pathname;
        } catch (probablyNotJson) {
          // Nothing
        }
        alertDialogOptions.message += `<br><small>${url}</small>`;
      }

      // Define alert title according to exception status
      if (exception.status && exception.status !== 401) {
        alertDialogOptions.title = `FEHLER_${exception.status}`;
        this.alertDialogService.showAlert(alertDialogOptions);
      }
    } else {
      this.alertDialogService.showAlert(alertDialogOptions);
    }
  }

  public async handleExceptionWithErrorPageRedirect(exceptionName: string, exception: any) {
    if (exception.status !== 401) {
      LoggerService.ERROR(this, exceptionName, exception);
      window.history.replaceState(null, '', '/');
      await this.router.navigateByUrl(`fehler/${(exception as HttpErrorResponse).status}?failedRoute=${this.router.url}`);
    }
  }

  public isAccessForbiddenException(exception: any): boolean {
    return exception instanceof HttpErrorResponse && exception.status === 403;
  }
}
